import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'lib/@mui';
import { Edit } from 'lib/@mui/Icons';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { setLocalStorage } from '../../helpers/helpersMeshBot';

import './style.scss';
import withAbilityGoEditMeshbot from '../../containers/Ezlo/EzloMeshbots/HOCs/withAbilityGoEditMeshbot';
import { PRIMARY } from '../../constants/MeshbotConstant';
import { ADVANCED_SCENES } from 'constants/ControllerFeatures';
import { shouldDisableSystemTcdsActions } from 'containers/Ezlo/EzloMeshbot/utils';
import { EZLOGIC_TITLE_EDIT_MESHBOT_FROM_ADVANCED_SCENE_1_74 } from 'constants/language_tokens';
import { Tooltip } from 'components';
import { useTranslate } from 'features/languages';

const MeshbotEditRule = ({ renderedCellValue: params, onClick }) => {
    const { t } = useTranslate();
    const ezloData = useSelector((state) => state.ezlo?.data?.[params?.serial]);
    const isTcdsDisabled = shouldDisableSystemTcdsActions(params, ezloData, ADVANCED_SCENES.VERSION_1_74);
    const isDisabled = params.isDisabled || !params.isMeshBotEditingEnabled || isTcdsDisabled;
    // TODO: refactoring needed, no localstorage here!!!
    const handleEdit = () => {
        setLocalStorage('createType', params.type);
        onClick(params);
    };

    return (
        <div className="meshbot-edit__wrapper">
            <Tooltip
                title={
                    isTcdsDisabled && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: t(EZLOGIC_TITLE_EDIT_MESHBOT_FROM_ADVANCED_SCENE_1_74),
                            }}
                        />
                    )
                }
                position="top"
            >
                <div>
                    <IconButton
                        color={PRIMARY}
                        onClick={handleEdit}
                        disabled={isDisabled}
                        className={classNames({ disabled: isDisabled })}
                    >
                        <Edit color={PRIMARY} />
                    </IconButton>
                </div>
            </Tooltip>
        </div>
    );
};

export default withAbilityGoEditMeshbot(MeshbotEditRule);

MeshbotEditRule.propTypes = {
    renderedCellValue: PropTypes.object,
};
